import { ElementTitle } from './component';
export * from './component';
export default ElementTitle;
